import { render, staticRenderFns } from "./vanguardEdit.vue?vue&type=template&id=32ac4faf&scoped=true&"
import script from "./vanguardEdit.vue?vue&type=script&lang=js&"
export * from "./vanguardEdit.vue?vue&type=script&lang=js&"
import style0 from "./vanguardEdit.vue?vue&type=style&index=0&id=32ac4faf&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32ac4faf",
  null
  
)

export default component.exports